import './appointment-popup.ajscss';

import { AppointmentService } from '@agent/core/contact/appointment.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IAppointmentCsr, IVisioAppointment } from '@commons/models/appointment';
import { ChannelUtil } from '@commons/util/helper/channel';
import { RxUtil } from '@commons/util/utilities/rx';
import { copy, IComponentController, IComponentOptions, ILogService, IQService, isDefined } from 'angular';
import moment from 'moment';
import { first, tap } from 'rxjs';

import {
  AgentSkillFacade,
  AppointmentTargetType,
  Campaign,
  CampaignNumberingType,
  CampaignType,
  ChanEnum,
  Configuration,
  CustomerData,
  CustomerService,
  isNotNullOrUndefined,
  MediaSkill,
  MomentService,
  Option,
  Skill,
  TimeSlot,
  TimeSlotType,
} from '@contact/upgrade';

import { IAppointmentDeprecatedService, ModalParamAppointment } from '../../appointment-deprecated.service';
import { ITargetSelection, TransferKey } from '../../transfer/models/transfer';
import templateUrl from './appointment-popup.html';

export const CREATE_MODE = 'CREATE';
export const POST_PONE_MODE = 'POST_PONE';

class AppointmentPopupCtrl implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  mode: string;
  responseId: string;
  contactId: string;

  contactUri: Option<string>;
  contactFirstName: Option<string>;
  contactLastName: Option<string>;
  skillsToPreselect: Option<string[]>;

  phoneValid: boolean = false;
  errorSubmited: boolean = false;
  public isMandatoryComment: number;
  availableSkills: Skill[] = [];
  csrSelectedskills: Skill[] = [];
  participantSkills: Skill[] = [];
  availableCampaigns: Campaign[] = [];
  selectedCampaign: Campaign | undefined;
  selectedCampaignEnableCsrReassign: boolean = false;
  selectedTimeSlot: TimeSlot | undefined;
  timeSlotsToBeSelected: TimeSlot[];
  public selectedCampaignType: string = 'SCHEDULED_CALL_BACK';

  appointment: IVisioAppointment | undefined;
  initDone: boolean = false;
  idCsr: string;
  loginCsr: string;
  firstnameCsr: string;
  lastnameCsr: string;

  isVisio: boolean = false;
  canInvite: boolean = false;
  inviteParticipant: boolean = false;
  selfCsr: boolean = true;
  assignCsrRights: boolean = false;
  labelFieldsetChooseCsr: string = '';
  labelFieldsetChooseParticipant: string = '';

  public Csrkey: TransferKey;
  public guestkey: TransferKey;
  public targetCsr: ITargetSelection;
  public targetGuest: ITargetSelection;
  public selectedLanguage: any;
  public languages: any;
  public failedValidationReason = '';

  public contactListBuffer: CustomerData[];
  public customCard: CustomerData | undefined;
  private contactSearchValue: string;

  constructor(
    private readonly $log: ILogService,
    private readonly $q: IQService,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly timeUtil: MomentService,
    private readonly customerService: CustomerService,
    private readonly agentSkillFacade: AgentSkillFacade,
    private readonly appointmentService: AppointmentService,
    public readonly configuration: Configuration
  ) {}

  private checkVisioIsValid(): boolean {
    if (!this.appointment) {
      return false;
    }

    // contact uuid
    if (!this.appointment.contactUuid) {
      this.failedValidationReason = 'contact.uuid';
      return false;
    }

    // contact phone
    if (!this.appointment.phone) {
      this.failedValidationReason = 'contact.phone';
      return false;
    }

    // contact email
    if (!this.appointment.email) {
      this.failedValidationReason = 'contact.email';
      return false;
    }

    // csr
    if (!this.appointment.idCsr) {
      this.failedValidationReason = 'csr.id';
      return false;
    }

    // skill
    if (!this.appointment.skillList || this.appointment.skillList.length === 0) {
      this.failedValidationReason = 'csr.skills';
      return false;
    }

    // MANUAL CHOOSE THE TARGET
    let targetCsrOK: boolean = this.checkTargetIsValid(this.targetCsr);
    if (!targetCsrOK) {
      this.failedValidationReason = 'target';
      return false;
    }

    // participant
    if (this.inviteParticipant) {
      if (!this.checkTargetIsValid(this.targetGuest)) {
        this.failedValidationReason = 'targetGuest';
        return false;
      }
    }

    // appointment
    if (!this.selectedTimeSlot) {
      this.failedValidationReason = 'timeslot';
      return false;
    }

    this.appointment.language = this.selectedLanguage.id;

    this.failedValidationReason = '';
    return true;
  }

  private checkPhoneIsValid(): boolean {
    if (this.appointment == null) {
      return false;
    }

    // comment
    if (this.isMandatoryComment === 1 && (!this.appointment || !this.appointment.contextComment)) {
      this.failedValidationReason = 'comment';
      return false;
    }

    if (!this.appointment.skillList || this.appointment.skillList.length === 0) {
      this.failedValidationReason = 'csr.skills';
      return false;
    }

    if (this.mode === CREATE_MODE) {
      return (
        this.appointment.phone != null &&
        this.appointment.phone !== '' &&
        this.phoneValid &&
        !!this.selectedCampaign &&
        !!this.selectedTimeSlot
      );
    } else {
      // if timeslot selected is different from existing
      return !!this.selectedTimeSlot && !!this.appointment && this.appointment.timeSlot.id !== this.selectedTimeSlot.id;
    }
  }

  get formIsValid(): boolean {
    if (this.selectedCampaignType === CampaignType.VISIO_SCHEDULED_CALL_BACK) {
      return this.checkVisioIsValid();
    }
    return this.checkPhoneIsValid();
  }

  $onInit(): void {
    this.initialize();
  }

  $onDestroy(): void {
    this.availableSkills = [];
  }

  cancel(): void {
    this.dismiss();
  }

  checkAndCleanPhone(newValue: string): void {
    if (this.appointment) {
      this.appointment.phone = newValue;
    }
  }

  getCreateMode(): string {
    return CREATE_MODE;
  }

  getPostPoneMode(): string {
    return POST_PONE_MODE;
  }

  submitForm(): void {
    if (this.appointment && this.selectedCampaignType === CampaignType.VISIO_SCHEDULED_CALL_BACK) {
      if (!this.inviteParticipant) {
        this.appointment.participant = undefined;
        this.appointment.participantSkillList = undefined;
      }
      this.appointment.language = this.selectedLanguage.id;
    }

    if (this.mode === CREATE_MODE) {
      this.createAppointment();
    } else {
      this.postPoneAppointment();
    }
  }

  createAppointment(): void {
    if (this.appointment && !!this.appointment.phone && this.phoneValid && !!this.selectedTimeSlot) {
      this.appointment.timeSlot = {
        id: this.selectedTimeSlot.id,
        beginDate: this.selectedTimeSlot.beginDate,
        endDate: this.selectedTimeSlot.endDate,
        type: TimeSlotType.CLOSED,
        contactThreshold: 0,
        contactCount: 0,
      };
      this.appointment.campaign = {
        id: this.selectedCampaign!!.id,
        name: '',
        beginDate: 0,
        endDate: 0,
        type: CampaignType[this.selectedCampaignType],
        description: '',
        timeSlots: [],
        maxTriesNb: 0,
        scriptArgumentUuid: '',
        enableCsrReassign: false,
        csrCanRefuseCall: false,
        csrCanCancelCall: false,
        stream: undefined,
        numberingType: CampaignNumberingType.PROGRESSIVE,
        previewDelay: 0,
      };
      // toast is created in service in case of creation fail
      this.appointmentDeprecatedService.createAppointment(this.appointment).then(
        () => {
          if (this.appointment && this.appointment.idCsr !== '' && this.selectedCampaignType !== CampaignType.VISIO_SCHEDULED_CALL_BACK) {
            this.appointmentService.getTodayAppointmentNumber();
          }
          this.close();
        },
        () => {
          this.toastDeprecatedService.alert('agent:toast.appointment_not_created');
        }
      );
    } else {
      this.errorSubmited = true;
    }
  }

  postPoneAppointment(): void {
    if (this.appointment && this.selectedTimeSlot) {
      let currentCampaignType = this.appointment.campaign.type;
      this.appointment.timeSlot = {
        id: this.selectedTimeSlot.id,
        beginDate: 0,
        endDate: 0,
        type: TimeSlotType.CLOSED,
        contactThreshold: 0,
        contactCount: 0,
      };
      this.appointment.campaign = {
        id: this.selectedCampaign!!.id,
        name: '',
        beginDate: 0,
        endDate: 0,
        type: CampaignType[this.selectedCampaignType],
        description: '',
        timeSlots: [],
        maxTriesNb: 0,
        scriptArgumentUuid: '',
        enableCsrReassign: false,
        csrCanRefuseCall: false,
        csrCanCancelCall: false,
        stream: undefined,
        numberingType: CampaignNumberingType.PROGRESSIVE,
        previewDelay: 0,
      };
      // toast is created in service in case of post pone fail
      this.appointmentDeprecatedService.changeAppointment(this.appointment).then(
        () => {
          if (this.appointment) {
            this.appointment.campaign = {
              ...this.appointment.campaign,
              type: currentCampaignType,
            };
            if (this.appointment.idCsr !== '' && this.selectedCampaignType !== CampaignType.VISIO_SCHEDULED_CALL_BACK) {
              this.appointmentService.getTodayAppointmentNumber();
            }
          }
          this.close();
        },
        () => {
          this.toastDeprecatedService.alert('agent:toast.appointment_not_postponed');
        }
      );
    }
  }

  readableTime(date: number): string {
    return '<time>' + this.timeUtil.readableTime(date) + '</time>';
  }

  readableTimeSlotSelect(timeSlot: TimeSlot) {
    return `${this.readableTimeSlotSelectWithoutContactThreshold(timeSlot)} (${timeSlot.contactCount}/${timeSlot.contactThreshold})`;
  }

  readableTimeSlotSelectWithoutContactThreshold(timeSlot: TimeSlot) {
    return `${this.readableTime(timeSlot.beginDate)} - ${this.readableTime(timeSlot.endDate)}`;
  }

  campaignChanged(): void {
    if (isDefined(this.selectedCampaign)) {
      this.appointmentDeprecatedService
        .getCampaignInfoWithOpenedTimeSlots(this.selectedCampaign!!.id, new Date(this.selectedCampaign!!.endDate))
        .pipe(first())
        .subscribe(campaign => {
          this.selectedCampaignEnableCsrReassign = campaign.enableCsrReassign;
          this.timeSlotsToBeSelected = campaign.timeSlots.filter(timeSlot => {
            if (this.selectedCampaignType === CampaignType.VISIO_SCHEDULED_CALL_BACK) {
              return timeSlot.type === TimeSlotType.OPENED && moment(timeSlot.endDate).isAfter();
            }
            return (
              timeSlot.type === TimeSlotType.OPENED &&
              timeSlot.contactCount < timeSlot.contactThreshold &&
              moment(timeSlot.endDate).isAfter()
            );
          });
        });
    } else {
      this.timeSlotsToBeSelected = [];
    }
  }

  canPrintCalendar(): boolean {
    return !!this.timeSlotsToBeSelected && this.timeSlotsToBeSelected.length > 0;
  }

  onTimeSlotSelected(timeSlot: TimeSlot | undefined): void {
    this.selectedTimeSlot = timeSlot;
  }

  private initializeCreateMode() {
    this.appointmentDeprecatedService
      .buildAppointment(this.contactUri, this.contactFirstName, this.contactLastName, this.skillsToPreselect)
      .then(
        (appointment: IVisioAppointment) => {
          this.appointment = appointment;
          this.appointment.idCsr = '';
          this.idCsr = this.sessionDeprecatedService.getProfile().id;
          this.loginCsr = this.sessionDeprecatedService.getProfile().login;
          this.firstnameCsr = this.sessionDeprecatedService.getProfile().firstname;
          this.lastnameCsr = this.sessionDeprecatedService.getProfile().lastname;
          this.agentSkillFacade
            .getAllActive(ChanEnum.Out.Visio)
            .pipe(
              tap((_mSkills: MediaSkill[]) => (this.csrSelectedskills = copy(_mSkills.map((_mSkill: MediaSkill) => _mSkill.skill)))),
              tap(() => (this.initDone = true))
            )
            .subscribe();
          // if visio not available, need to update available skills
          this.appointmentDeprecatedService.getSkills().then(
            skills => {
              this.availableSkills = copy(skills);
            },
            () => {
              this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
              this.initDone = false;
            }
          );
          this.appointmentDeprecatedService.getCampaignsByDomain().then(
            campaigns => {
              this.availableCampaigns = campaigns;
            },
            () => {
              this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_campaigns');
            }
          );
        },
        () => {
          this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
        }
      );
  }

  private initializePostPoneMode() {
    if (this.appointment) {
      this.appointmentDeprecatedService
        .getCampaign(this.appointment.campaign.id)
        .pipe(first())
        .subscribe(campaign => {
          this.selectedCampaign = campaign;
          this.campaignChanged();
          this.initializeContextCommentField();
          this.initDone = true;
        });
    }
  }

  private initializeContextCommentField() {
    if (
      !!this.appointment &&
      this.selectedCampaignType === CampaignType.SCHEDULED_CALL_BACK &&
      !!this.appointment.phone &&
      this.appointment.phone.length > 0 &&
      !!this.appointment.idContact &&
      this.appointment.idContact.length > 0
    ) {
      this.appointmentDeprecatedService
        .getCampaignContactById(this.appointment.idContact)
        .pipe(isNotNullOrUndefined(), first())
        .subscribe(appointment => {
          if (!!this.appointment && !!appointment.optionalContent && !!appointment.optionalContent.CONTEXT_COMMENT) {
            this.appointment.contextComment = appointment.optionalContent.CONTEXT_COMMENT;
          }
        });
    }
  }

  private initialize() {
    // rights
    this.isMandatoryComment = this.appointmentDeprecatedService.mandatoryComment;

    this.isVisio = this.sessionDeprecatedService.hasPermission('CSR::visio_appointment:create');
    this.canInvite = this.sessionDeprecatedService.hasPermission('CSR::visio_appointment:invite');
    this.assignCsrRights = this.sessionDeprecatedService.hasPermission('CSR_VISIO_OUTGOING::visio_appointment:have_priority');

    this.selectedLanguage = { id: 'fr_FR', name: 'Français' };
    this.languages = [
      { id: 'fr_FR', name: 'Français' },
      { id: 'en_US', name: 'Anglais' },
    ];
    this.labelFieldsetChooseCsr = 'agent:popin.create_appointment.target_fieldset';
    this.labelFieldsetChooseParticipant = 'agent:popin.create_appointment.participant_fieldset';

    // read the modal parameter, type of modalParamRecord
    let param: ModalParamAppointment = this.resolve();
    if (isDefined(param)) {
      this.mode = Option.of(param.mode).getOrElse(CREATE_MODE);
      // CREATE
      this.responseId = Option.of(param.responseId).getOrElse('');
      this.contactId = Option.of(param.contactId).getOrElse('');
      this.contactUri = Option.of(param.contactUri);
      this.contactFirstName = Option.of(param.contactFirstName);
      this.contactLastName = Option.of(param.contactLastName);
      this.skillsToPreselect = Option.of(param.skillsToPreselect);
      // POSTPONE
      this.appointment = param.appointment || undefined;
    } else {
      this.$log.error('[AppointmentPopupCtrl] missing compulsory modal parameter');
    }

    if (this.mode === CREATE_MODE) {
      this.initializeCreateMode();
    } else {
      this.initializePostPoneMode();
    }
    if (!this.isVisio) {
      this.selectedCampaignType = CampaignType.SCHEDULED_CALL_BACK;
    }
  }

  changeCampaignType() {
    if (!!this.appointment) {
      // we reset all the fields when changing campaign type
      this.selectedCampaign = undefined;
      this.campaignChanged();
      this.contactSearchValue = '';
      this.appointment.skillList = [];
      this.csrSelectedskills.forEach((s: any) => {
        s.selected = false;
        s.displayed = false;
        s.chosen = false;
      });
      this.resetSelectedContact();
      this.appointment.comment = '';

      // NORMAL
      if (this.selectedCampaignType === CampaignType.SCHEDULED_CALL_BACK) {
        this.appointmentDeprecatedService.getSkills().then(
          skills => {
            // we make a copy here because chosen will add attributes on object list but won't reset them if we use the same list
            // at next open see ODECSCNGACCEPTANCE-7899
            this.availableSkills = copy(skills);
            this.appointment!.skillList = [];
            // uggly : after copy reselect skills with local list object...
            this.skillsToPreselect.getOrElse([]).forEach((skillName: string) => {
              this.availableSkills
                .filter((currentAvailableSkill): boolean => skillName === currentAvailableSkill.name)
                .forEach(skillToPreselect => this.appointment!.skillList.push(skillToPreselect));
            });
          },
          () => {
            this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
          }
        );
      }
      // VISIO
      if (this.selectedCampaignType === CampaignType.VISIO_SCHEDULED_CALL_BACK) {
        this.appointmentDeprecatedService.getVisioSkills().then(
          skills => {
            // we make a copy here because chosen will add attributes on object list but won't reset them if we use the same list
            // at next open see ODECSCNGACCEPTANCE-7899
            this.availableSkills = copy(skills);
            this.participantSkills = copy(skills);
            this.appointment!.skillList = [];
          },
          () => {
            this.toastDeprecatedService.alert('agent:toast.cannot_retrieve_skills');
          }
        );
      }
    }
  }

  createIAppointmentCsr(_uuid: string, _firstname: string, _lastname: string, _login: string): IAppointmentCsr {
    return {
      uuid: _uuid || '',
      firstName: _firstname || '',
      lastName: _lastname || '',
      login: _login || '',
    };
  }

  setAppointmentCsr(_idCsr: string, _loginCsr: string, _firstnameCsr: string, _lastnameCsr: string) {
    if (!!this.appointment) {
      this.appointment.idCsr = _idCsr || '';
      this.appointment.loginCsr = _loginCsr || '';
      this.appointment.firstnameCsr = _firstnameCsr || '';
      this.appointment.lastnameCsr = _lastnameCsr || '';
    }
  }

  onParticipantChange() {
    if (!this.inviteParticipant && !!this.appointment) {
      this.appointment.participant = undefined;
    }
  }

  onTargetCsrSelected({ target }) {
    this.targetCsr = target;
    if (!!this.appointment && !!target) {
      this.appointment.targetList = [];
      this.appointment.skillList = target.skills ? target.skills : [];
      if (this.selfCsr) {
        this.setAppointmentCsr(this.idCsr, this.loginCsr, this.firstnameCsr, this.lastnameCsr);
      } else {
        if (!!target.csr && !!target.csr.uuid) {
          this.setAppointmentCsr(target.csr.uuid, target.csr.login, target.csr.firstName, target.csr.lastName);
        } else {
          this.setAppointmentCsr('', '', '', '');
        }
      }
      if (!!target.teams && target.teams.length > 0) {
        this.appointment.targetList.push(
          target.teams.map(_team => ({
            uuid: _team.id,
            name: _team.name,
            type: AppointmentTargetType.TEAM,
          }))
        );
      }
      if (!!target.groups && target.groups.length > 0) {
        this.appointment.targetList.push(
          target.groups.map(_group => ({
            uuid: _group.id,
            name: _group.name,
            type: AppointmentTargetType.GROUP,
          }))
        );
      }
    }
  }

  onTargetGuestSelected({ target }) {
    this.targetGuest = target;
    if (!!this.appointment && !!target) {
      this.appointment.participantSkillList = !!target.skills ? target.skills : [];
      this.appointment.participantTargetList = [];

      if (!!target.csr && !!target.csr.uuid) {
        this.appointment.participant = this.createIAppointmentCsr(
          target.csr.uuid,
          target.csr.firstName,
          target.csr.lastName,
          target.csr.login
        );
      } else {
        this.appointment.participant = undefined;
      }

      if (!!target.teams && target.teams.length > 0) {
        this.appointment.participantTargetList.push(
          target.teams.map(_team => ({
            uuid: _team.id,
            name: _team.name,
            type: AppointmentTargetType.TEAM,
          }))
        );
      }
      if (!!target.groups && target.groups.length > 0) {
        this.appointment.participantTargetList.push(
          target.groups.map(_group => ({
            uuid: _group.id,
            name: _group.name,
            type: AppointmentTargetType.GROUP,
          }))
        );
      }
    }
  }

  onTargetMailChange({ target }) {
    if (this.appointment) {
      this.appointment.email = target;
    }
  }

  onTargetPhoneChange({ target }) {
    if (this.appointment) {
      this.appointment.phone = target;
    }
  }

  checkTargetIsValid(target: ITargetSelection): boolean {
    return !!target && !!target.skills && target.skills.length > 0;
  }

  searchCutomerCard(): void {
    this.contactListBuffer = [];
    RxUtil.toPromise(this.customerService.searchByPartialNameOrUri({ autocomplete: this.contactSearchValue, size: 100 }), this.$q).then(
      ({ data }) => {
        this.contactListBuffer = data
          .map(doc => ({
            customer: CustomerService.toEntity(doc),
            addresses: doc.addresses.map(address => CustomerService.toCustomerAddress(doc, address)),
          }))
          .filter(
            customerCard =>
              // filter the customer cards so as to make sure that all of the candidates have both phone and email addresses
              customerCard.addresses.some(address => ChannelUtil.equals(address.channel, ChanEnum.In.Phone) && address.uri) &&
              customerCard.addresses.some(address => ChannelUtil.equals(address.channel, ChanEnum.In.Mail) && address.uri)
          )
          // sort by first name
          .sort((customA, customB) => customA.customer.firstname.localeCompare(customB.customer.firstname));
      }
    );
  }

  onCustomerCardSelected() {
    let data = this.customCard;
    if (!!this.appointment && !!data) {
      let emails: string[] = data.addresses.filter(({ channel }) => ChannelUtil.equals(channel, ChanEnum.In.Mail)).map(myAdr => myAdr.uri);
      let phones: string[] = data.addresses.filter(({ channel }) => ChannelUtil.equals(channel, ChanEnum.In.Phone)).map(myAdr => myAdr.uri);

      if (!!emails) {
        this.appointment.email = emails[0];
      }
      this.phoneValid = false;
      if (!!phones) {
        this.appointment.phone = phones[0];
        this.phoneValid = true;
      }
      this.appointment.contactFirstName = data.customer.firstname || '';
      this.appointment.contactLastName = data.customer.lastname || '';
      this.appointment.contactUuid = data.customer.id;
      if (!!data.customer.externalId) {
        this.appointment.externalContactId = data.customer.externalId;
      }
    }
  }

  resetSelectedContact() {
    if (!!this.appointment) {
      this.customCard = undefined;
      this.appointment.email = undefined;
      this.appointment.phone = '';
      this.appointment.contactFirstName = '';
      this.appointment.contactLastName = '';
      this.appointment.contactUuid = '';
      this.appointment.externalContactId = '';
    }
  }
}

export class AppointmentPopup implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    resolve: '&',
  };
  controller = [
    '$log',
    '$q',
    'sessionDeprecatedService',
    'appointmentDeprecatedService',
    'toastDeprecatedService',
    'momentService',
    'customerService',
    'agentSkillFacade',
    'appointmentService',
    AppointmentPopupCtrl,
  ];
}

export default 'appointmentPopup';
